import { Component, Output, Input, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login-error',
  templateUrl: './login-error.component.html',
  styleUrls: ['./login-error.component.scss'],
})
export class LoginErrorComponent {
  @Input() message:string;
  @Output('on-retry') onRetryEvent: EventEmitter<any> = new EventEmitter();

  constructor(private router:Router) {}

  handleRetry = () => {
    this.onRetryEvent.emit();
  };
}
